import BaseLayout from '@/components/BaseLayout.vue'
import api from '@/services/api';

export default {
    name: 'education-my-tests',

    data() {
        return {
            quizzes: [],
        };
    },

    components: {
        BaseLayout
    },

    methods: {
        /**
         * Get education videos from API
         */
        getVideos() {
            api.get('/api/get_my_promotion_education_quizzes')
                .then((response) => {
                    this.quizzes = response.data.body.entries;
                });
        },
    },

    watch: {
        'user.pcmsId': function (){
            this.getVideos();
        }
    },

    mounted() {
        this.getVideos();
    },
}
